import {Injectable} from '@angular/core';
import {BehaviorSubject, filter, map, Observable} from "rxjs";

import {CurrentUser, CurrentUserData} from "@numizmat/services-models/account";

@Injectable({
  providedIn: 'root'
})
export class CurrentUserStateService {
  private loginState$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private currentUser$: BehaviorSubject<CurrentUser | undefined> = new BehaviorSubject<CurrentUser | undefined>(undefined);

  public getLoginState(): Observable<boolean> {
    return this.loginState$.asObservable();
  }

  public setLoginState(loginState: boolean): void {
    this.loginState$.next(loginState);
  }

  public getCurrentUser(): Observable<CurrentUser> {
    return this.currentUser$.asObservable().pipe(
      filter((currentUser: CurrentUser | undefined) => !!currentUser),
      map((currentUser: CurrentUser | undefined) => currentUser as CurrentUser)
    );
  }

  public setCurrentUser(user: CurrentUser): void {
    this.currentUser$.next(user);
  }

  public updateCurrentUserData(partialCurrentUserData: Partial<CurrentUserData>): void {
    const currentUser = this.currentUser$.value;
    if (!!currentUser?.userData) {
      this.currentUser$.next({
        loggedIn: currentUser?.loggedIn,
        userData: {
          ...currentUser.userData,
          ...partialCurrentUserData,
        },
      });
    }
  }
}
